import React from "react";
import { graphql } from "gatsby";
import { ArboretumHero } from "./ArboretumHero";
import {
  KontentLinks,
  KontentMediaImage,
  KontentMultiChoice,
  StringValue,
} from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { formatLinks } from "../../../lib/links";
import { formatImages } from "../../../lib/images";

interface Props {
  height: KontentMultiChoice<"short" | "tall" | "xshort">;
  background_image: { value: KontentMediaImage[] };
  logo_image: { value: KontentMediaImage[] };
  content_category_tax: KontentMultiChoice<string>;
  headline: StringValue;
  intro_text: StringValue;
  id: string;
}

const ArboretumHeroContainer: React.FC<Props> = ({
  background_image,
  logo_image,
  content_category_tax,
  headline,
  intro_text,
  id,
  ...props
}) => {
  const height = getMultiChoice(props.height);
  const images = formatImages(background_image.value[0]?.elements);
  const logo = formatImages(logo_image?.value[0]?.elements);

  return (
    <ArboretumHero
      id={id}
      height={height}
      desktopImage={images.largeImage}
      mobileImage={images.smallImage}
      logoImage={logo.largeImage}
      contentCategory={content_category_tax?.value[0]?.name}
      headline={headline.value}
      introText={intro_text.value}
    ></ArboretumHero>
  );
};

export default ArboretumHeroContainer;

export const fragmentArboretumHeroContainer = graphql`
  fragment ArboretumHero on kontent_item_component___arboretum_hero {
    elements {
      height {
        value {
          codename
        }
      }
      background_image {
        value {
          ...kontentMediaImage
          ... on kontent_item_media___image {
            elements {
              image {
                value {
                  gatsbyImageData
                }
              }
              small_image {
                value {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
      content_category_tax {
        value {
          name
        }
      }
      headline {
        value
      }
      intro_text {
        value
      }
      logo_image {
        value {
          ...kontentMediaImage
        }
      }
    }
  }
`;
